// extracted by mini-css-extract-plugin
module.exports = {"primaryHub":"Banner_primaryHub__E6TVc","arrow":"Banner_arrow__LoAqt"};